import React, { useEffect } from "react"
import { IMG } from "../common/CONST"
import { useStore } from "../../stores/RootStoreContext"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { Link } from "react-router-dom"
import {
  BASE_RATES,
  CLIENT_CONTRACTOR_ROUTE,
  CURRENCY_REPLENISHMENT_ROUTE,
  DASHBOARD_ROUTE,
  ORDER_ROUTE,
  RATES_ROUTE,
  REPLENISHMENT_ROUTE,
  REQUEST_ROUTE
} from "../../routes"
import { CONFIG } from "../../CONFIG"
import { useInstancesStore } from "@/stores/instancesStore"
import { useUnreadStore } from "@/stores/unreadStore"

export const MenuClient: React.FC<{ active: string }> = ({ active }) => {
  const { userStore } = useStore()
  const { unreadList, setUnreadList } = useUnreadStore()
  const { instancesList, setInstances } = useInstancesStore()

  if (!userStore.isClient) {
    userStore.setToken("")
    window.location.href = "/"
  }

  useEffect(() => {
    fetchUnread()

    const intervalId = setInterval(() => {
      fetchUnread()
    }, CONFIG.fetchUnreadsInterval)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  const fetchUnread = () => {
    TrinityAPI.getUnreadConversations("", response => {
      if (response.status === 200) {
        setUnreadList(response.data)
      }
    })
    TrinityAPI.getActionsRequired(response => {
      if (response.status === 200) {
        setInstances(response.data)
      }
    })
  }

  const countMsgByType = (type: string): string => {
    let count = 0
    unreadList?.items.forEach(i => {
      count += i.type === type ? i.num : 0
    })
    return count > 0 ? count.toString() : ""
  }

  const countInstanceByType = (type: string) => {
    let count = 0
    instancesList?.items.forEach(i => {
      count += i.type === type ? i.num : 0
    })
    return count > 0 ? count.toString() : ""
  }

  return (
    <header className="header">
      <Link to={DASHBOARD_ROUTE} className="logo-header">
        <img src={IMG.sign} alt="" className="logo-header-img" />
        <span>trinity</span>
      </Link>
      <nav className="header-nav">
        <div className="header-nav-list">
          <Link className={`header-nav-item${active === "dashboard" ? "-active" : ""}`} to={DASHBOARD_ROUTE}>
            <img src={IMG.home} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Главная</div>
          </Link>
          <Link className={`header-nav-item${active === "request" ? "-active" : ""}`} to={REQUEST_ROUTE}>
            <img src={IMG.requests} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Запросы</div>
            <span className="span-message">{countMsgByType("REQUEST")}</span>
            <span className="span-actions">{countInstanceByType("REQUEST")}</span>
          </Link>
          <Link className={`header-nav-item${active === "replenishment" ? "-active" : ""}`} to={REPLENISHMENT_ROUTE}>
            <img src={IMG.deals} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Пополнения рублевые</div>
            <span className="span-message">{countMsgByType("REPLENISHMENT")}</span>
            <span className="span-actions">{countInstanceByType("REPLENISHMENT")}</span>
          </Link>
          <Link
            className={`header-nav-item${active === "currency-replenishment" ? "-active" : ""}`}
            to={CURRENCY_REPLENISHMENT_ROUTE}
          >
            <img src={IMG.deals} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Пополнения валютные</div>
            <span className="span-message">{countMsgByType("CURREPLENISHMENT")}</span>
            <span className="span-actions">{countInstanceByType("CURREPLENISHMENT")}</span>
          </Link>
          <Link className={`header-nav-item${active === "order" ? "-active" : ""}`} to={ORDER_ROUTE}>
            <img src={IMG.orders} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Ордера</div>
            <span className="span-message">{countMsgByType("ORDER")}</span>
          </Link>
          <Link className={`header-nav-item${active === "contractor" ? "-active" : ""}`} to={CLIENT_CONTRACTOR_ROUTE}>
            <img src={IMG.profile} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Контрагенты</div>
          </Link>
          <Link className={`header-nav-item${active === "base-client-rates" ? "-active" : ""}`} to={BASE_RATES}>
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Ставки платформы</div>
          </Link>
          <Link className={`header-nav-item${active === "rates" ? "-active" : ""}`} to={RATES_ROUTE}>
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Курсы валют</div>
          </Link>
        </div>
      </nav>
    </header>
  )
}
